import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class GalaxyInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
    private router: Router) {
  }



  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // if (request.url != 'https://fcm.googleapis.com/fcm/send') {

    request = request.clone({

      setHeaders: {
        Authorization: `Bearer ${this.authService.getAuthToken()}`,
       // Secret_key: "FVJF6YCGKLSSKERB5$$OO8"
        // xapikey: "FVJF6YCGKLSSKERB5$$OO8"
      },

    });

    // }

    return next.handle(request).pipe(catchError(error => this.handleError(error, request, next)))
  }

  private handleError(err: HttpErrorResponse, request: HttpRequest<any>, next: HttpHandler): Observable<any> {

    console.log(err)
    // if token has expired
    if (err.status == 401) {

      this.router.navigate(['']);
    }
    // server error
    else if (err.status == 500) {
      //  this.router.navigate(['']);
    }
    // rethrow Error
    return throwError(err);
  }
}
